// Mock data for the wedding website

export const coupleData = {
  bride: "Polina",
  groom: "Evgeniy",
  weddingDate: "2026-09-07",
  venue: "Talici Hill",
  location: "Montenegro",
  venueWebsite: "https://talicihill.com/"
};

export const scheduleData = {
  description: "Join us for a three-day celebration of love in the breathtaking Montenegro.",
  days: [
    {
      id: 1,
      dayNumber: "Day 1",
      date: "September 6, 2026",
      dateShort: "6th September",
      title: "Welcome & Pre-Wedding",
      isWeddingDay: false,
      events: [
        {
          time: "19:50",
          title: "Arrival at Venue",
          description: "Welcome to Talici Hill! Please arrive and check in at the venue.",
          location: "Talici Hill Reception"
        },
        {
          time: "20:00",
          title: "Welcome Dinner Begins",
          description: "Join us for a delightful welcome dinner to kick off our celebration.",
          location: "Talici Hill Garden"
        },
        {
          time: "23:00",
          title: "End of Welcome Dinner",
          description: "Conclude the evening and rest up for the big day ahead.",
          location: "Talici Hill Garden"
        }
      ]
    },
    {
      id: 2,
      dayNumber: "Day 2",
      date: "September 7, 2026",
      dateShort: "7th September",
      title: "Wedding Day",
      isWeddingDay: true,
      events: [
        {
          time: "17:00",
          title: "Welcome Drinks At Villa",
          description: "Gather for pre-ceremony drinks and mingle with fellow guests.",
          location: "Talici Hill Reception"
        },
        {
          time: "17:30",
          title: "Photoshoots",
          description: "Professional photography session with the couple and wedding party.",
          location: "Ceremony Garden"
        },
        {
          time: "18:00",
          title: "Ceremony",
          description: "Witness our vows in an intimate ceremony overlooking the Adriatic Sea.",
          location: "Ceremony Garden"
        },
        {
          time: "18:30",
          title: "Aperitif",
          description: "Celebrate with champagne and canapés while enjoying the sunset.",
          location: "Dinner Area"
        },
        {
          time: "19:00",
          title: "Dinner",
          description: "A multi-course dinner featuring the finest local cuisine.",
          location: "Dinner Area"
        },
        {
          time: "22:00",
          title: "Cake",
          description: "Join us for the cutting of our wedding cake.",
          location: "Dinner Area"
        },
        {
          time: "23:00",
          title: "Afterparty",
          description: "Dance the night away under the Montenegro sky.",
          location: "Dinner Area"
        }
      ]
    },
    {
      id: 3,
      dayNumber: "Day 3",
      date: "September 8, 2026",
      dateShort: "8th September",
      title: "Farewell Celebration",
      isWeddingDay: false,
      events: [
        {
          time: "12:00",
          title: "Pool Party and Pizza",
          description: "Join us for a relaxed pool party with delicious pizza to close our celebration.",
          location: "Talici Hill Pool Area"
        }
      ]
    }
  ],
  venue: {
    name: "Talici Hill",
    address: "Cendulica, Brca, Sutomore 85355, Montenegro",
    coordinates: {
      lat: 42.13051886690426,
      lng: 19.067913878427394
    }
  }
};

export const galleryData = {
  title: "Talici Hill, Montenegro",
  photos: [
    {
      id: 1,
      url: "https://customer-assets.emergentagent.com/job_wedding-countdown-pk/artifacts/n6ljjw2b_2022.talici-hill-montenegro-wedding-venue-events-mice-2.jpg",
      caption: "Elegant Stone Terrace"
    },
    {
      id: 2,
      url: "https://customer-assets.emergentagent.com/job_wedding-countdown-pk/artifacts/2ufv9u7y_2022.talici-hill-montenegro-wedding-venue-events-mice-8.jpg",
      caption: "Olive Grove Ceremony"
    },
    {
      id: 3,
      url: "https://customer-assets.emergentagent.com/job_wedding-countdown-pk/artifacts/m7pg4e4p_2022.talici-hill-montenegro-wedding-venue-events-mice-15.jpg",
      caption: "Adriatic Sea Views"
    },
    {
      id: 4,
      url: "https://customer-assets.emergentagent.com/job_wedding-countdown-pk/artifacts/uypggmil_2022.talici-hill-montenegro-wedding-venue-events-mice-34.jpg",
      caption: "Garden & Pool Overlook"
    },
    {
      id: 5,
      url: "https://customer-assets.emergentagent.com/job_wedding-countdown-pk/artifacts/bpx1s8j0_2022.talici-hill-montenegro-wedding-venue-events-mice-56.jpg",
      caption: "Romantic String Lights"
    },
    {
      id: 6,
      url: "https://customer-assets.emergentagent.com/job_wedding-countdown-pk/artifacts/n18kkrlp_gallery-talici-hill-rustic-villas-6390.jpeg",
      caption: "Stunning Sunset View"
    },
    {
      id: 7,
      url: "https://customer-assets.emergentagent.com/job_wedding-countdown-pk/artifacts/ttncefak_64277e96.avif",
      caption: "Evening Venue Ambiance"
    }
  ]
};

export const accommodationData = {
  title: "Where to Stay",
  description: "We've reserved room blocks at these wonderful accommodations for your convenience.",
  options: [
    {
      id: 1,
      name: "Talici Hill Resort",
      type: "Venue Hotel",
      description: "Stay where the celebration happens! Limited rooms available at our venue with exclusive wedding guest rates.",
      amenities: ["Pool", "Spa", "Restaurant", "Sea View"],
      website: "https://talicihill.com/",
      priceRange: "€€€€",
      image: "https://images.unsplash.com/photo-1566073771259-6a8506099945?w=800"
    },
    {
      id: 2,
      name: "Coastal Boutique Hotel",
      type: "Luxury Hotel",
      description: "A charming boutique hotel just 10 minutes from the venue, offering modern comfort with traditional Montenegrin charm.",
      amenities: ["Beach Access", "Breakfast Included", "Free Shuttle"],
      distance: "10 min drive",
      priceRange: "€€€",
      image: "https://images.unsplash.com/photo-1542314831-068cd1dbfeeb?w=800"
    },
    {
      id: 3,
      name: "Mountain View Villa",
      type: "Villa Rental",
      description: "Perfect for families or groups. Spacious villas with stunning mountain views and private pools.",
      amenities: ["Private Pool", "Kitchen", "Multiple Bedrooms"],
      distance: "15 min drive",
      priceRange: "€€",
      image: "https://images.unsplash.com/photo-1602002418082-a4443e081dd1?w=800"
    }
  ],
  travelTips: [
    "Book early as September is peak season in Montenegro",
    "Airport transfers can be arranged - contact us for details",
    "Most hotels offer wedding guest discounts - mention our names when booking"
  ]
};

export const rsvpData = {
  dinnerMenu: {
    coldAppetizers: [
      { 
        value: "montenegrin", 
        label: "Traditional Montenegrin Dish (180g)",
        description: "Njeguška prosciutto, homemade cheese, smoked cheese, cheese with herbs, and olives"
      },
      { 
        value: "salmon", 
        label: "Salmon Tartare (180g)",
        description: "Served with avocado and pickled kohlrabi"
      },
      { 
        value: "quinoa", 
        label: "Quinoa Salad (200g) - Vegan",
        description: "With dried tomatoes, avocado, and sunflower seeds"
      }
    ],
    warmAppetizers: [
      { 
        value: "eggplant", 
        label: "Rolled Eggplant (250g)",
        description: "Stuffed with cream cheese"
      },
      { 
        value: "risotto-mushroom", 
        label: "Risotto with Forest Mushrooms (250g) - Vegan",
        description: "With crunchy hazelnuts"
      }
    ],
    salads: [
      { 
        value: "arugula", 
        label: "Arugula Salad (180g)",
        description: "With parmesan, pear, and cherry tomato"
      },
      { 
        value: "paprika", 
        label: "Smoked Paprika Salad (180g) - Vegan",
        description: "With seeds and balsamic dressing"
      }
    ],
    mains: [
      { 
        value: "monkfish", 
        label: "Monkfish (300g)",
        description: "With saffron risotto and fresh sprouts"
      },
      { 
        value: "beef", 
        label: "Beef Medallions (300g)",
        description: "With sautéed vegetables and celery purée"
      },
      { 
        value: "tofu", 
        label: "Grilled Tofu (300g) - Vegan",
        description: "With vegetable noodles and fig sauce"
      }
    ]
  },
  dietaryOptions: [
    { value: "none", label: "No restrictions" },
    { value: "gluten-free", label: "Gluten-free" },
    { value: "dairy-free", label: "Dairy-free" },
    { value: "nut-allergy", label: "Nut allergy" },
    { value: "other", label: "Other (please specify)" }
  ]
};
